module.exports = __webpack_public_path__ + "img/icon-item-oil.8ef272a0.svg";